import Marionette from "marionette";
import template from "classes/modals/cam/view/template/CamPhotoItemView.html";
import "css!classes/modals/cam/view/css/CamPhotoItemView";


let CamPhotoItemView = Marionette.ItemView.extend("CamPhotoItemView", {
    tagName: "li",
    className: "CamPhoto",
    template,

    ui: {
        $a: ".CamPhoto-img",
        $remove: ".CamPhoto-remove"
    },

    events: {
        "click @ui.$a": "onClick",
        "click @ui.$remove": "onClickRemove"
    },

    onClickRemove(e) {
        e.preventDefault();
        this.trigger("remove");
        this.model.remove();
    },

    onClick(e) {
        e.preventDefault();
        this.trigger("click");
    }
});

export default CamPhotoItemView;
